/* eslint-disable max-len */
import { SvgProps } from './types'

export const HandStarIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="36"
      height="41"
      viewBox="0 0 36 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_1022_12174)">
        <path d="M25.8066 22.7859L21.3569 20.4922L16.9426 22.8486C16.4984 23.0839 15.9756 22.7114 16.0542 22.2174L16.864 17.2889L13.2516 13.8269C12.8899 13.4779 13.0825 12.8663 13.5817 12.7918L18.5306 12.039L20.7122 7.54573C20.9324 7.09484 21.577 7.087 21.8011 7.53789L24.0495 11.9998L29.0102 12.682C29.5094 12.7526 29.7138 13.3603 29.3561 13.7131L25.7948 17.2262L26.6753 22.1429C26.7657 22.6369 26.2468 23.0172 25.7987 22.7898L25.8066 22.7859Z" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28.2869 5.68701L27.2099 7.16907" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34.7689 10.7021L32.6855 11.3804" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M32.6069 18.9396L30.8577 18.375" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.0047 18.9357L11.7539 18.3711" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.83887 10.7021L9.92613 11.3765" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.3207 5.68701L15.4017 7.16907" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.2587 1.02539V3.09165" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.5315 30.157L21.412 29.8786C21.8719 29.8551 22.2807 29.663 22.5794 29.365C22.8782 29.067 23.0826 28.6358 23.0983 28.1653C23.1297 27.1655 22.3239 26.3382 21.3176 26.3421L17.8035 26.3578C17.8035 26.3578 14.592 24.3268 11.7932 24.566C9.74529 24.7385 6.7618 27.6203 5.30347 29.1494" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.1061 28.3731L26.2783 26.4832L29.4898 23.2799C30.7044 22.0684 32.6148 21.8881 34.0338 22.8526L34.9772 23.4956L24.2225 33.9132C23.5228 34.5679 22.599 34.9365 21.6399 34.9365L11.5102 35.3403" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.0362 39.9862L12.4536 37.5749C12.8113 37.2181 12.8113 36.6378 12.4536 36.281L4.73745 28.5845C4.37975 28.2277 3.79798 28.2277 3.44028 28.5845L1.02283 30.9958L10.0401 39.9901L10.0362 39.9862Z" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1022_12174">
          <rect width="35" height="40" fill="white" transform="translate(0.5 0.503906)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
